<template>
    <!-- <v-container class="mb-12"> -->
    <!-- <v-card class="card-video text-center"> -->

    <!-- <youtube class="video-play" :video-id="videoId" :player-vars="{ start: playON }"></youtube> -->
        <div 
        class="container-video">
            <iframe
                class="responsive-iframe "
                :src="videoUrl"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            >
            </iframe>
        </div>


    <!-- <div class="mask" v-if="playON">
        <v-btn @click="play"  light icon>
          <img src="../../assets/icons/icon-play.png" alt="Play" class="play" title="Play">
        </v-btn>
        <img src="../../assets/icons/roma_mask.png" alt="" class="roma-mask">
      </div> -->
    <!-- </v-card> -->
    <!-- <v-card class="description">
      <p >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
    </v-card> -->
    <!-- </v-container> -->
</template>

<script>
// import Vue from "vue";
// import VueYouTubeEmbed from "vue-youtube-embed";
// Vue.use(VueYouTubeEmbed);

export default {
    name: "RomaVideo",
    props: {
        resource: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            videoId: "B-Gt430Y-GY",
            nextId: "",
            videos: [],
            width: "640",
            height: "360",
            playON: true
        };
    },
    computed: {
        videoUrl: function() {
            const videoId = this.getIdYoutubeVideo(this.resource.link);
            return `https://www.youtube.com/embed/${videoId}`;
        }
    },
    mounted() {
        this.getIdYoutubeVideo(this.resource.link);
    },
    methods: {
        ready(event) {
            this.player = event.target;
        },
        play() {
            this.playON = false;
        },
        getIdYoutubeVideo(youtubeUrl) {
            const urlArray = youtubeUrl.split("=");
            const videoId = urlArray[urlArray.length - 1];

            return videoId;
        }
    }
};
</script>

<style lang="scss" scoped>

.container-video {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.19);
    position: relative;
    overflow: hidden;
    width: 100%;
    // margin: auto;
    padding-top: 56.25%;
    background: url(../../assets/images/preloaders/preloader.gif) center center
        no-repeat;
}

.responsive-iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
}

.card-video {
    position: relative;
    background: #101010 0 0 no-repeat padding-box;
    box-shadow: 0 6px 6px #0000001c;
    border-radius: 25px;
    padding: 7px 25px;
    color: #ffffff;
    margin-top: 5px;
    margin-left: 20%;
    margin-right: 20%;
    .mask {
        border-radius: 15px;
        position: absolute;
        z-index: 1;
        background: #101010 !important;
        top: 0;
        left: auto;
        right: auto;
        width: 100%;
        height: 100%;
        padding: 23% 10px 0 1px;
    }

    .roma-mask {
        position: absolute;
        left: 0;
        bottom: 9px;
    }

    .play:hover {
        width: 105px;
        /*box-shadow: 0 10px 25px rgba(78, 78, 78, 0.15) !important;*/
    }
}
.description {
    margin-top: 2%;
    margin-left: 20%;
    margin-right: 20%;
    background: transparent;
    border: none;
    box-shadow: none;
    p {
        text-align: left;
        font: Regular 18px/22px Cabin;
        letter-spacing: 0;
        color: #484848;
    }
}
</style>
